import {useEffect} from 'react';

const useAuthRefresh = (
  INTERVAL_IN_MINUTES = 0,
  refreshAuthToken: CallableFunction,
) => {
  const INTERVAL_IN_MILLISECONDS = INTERVAL_IN_MINUTES * 60 * 1000;

  useEffect(() => {
    const interval = setInterval(() => {
      refreshAuthToken();
    }, INTERVAL_IN_MILLISECONDS);
    return () => {
      clearInterval(interval);
    };
  }, []);
};

export default useAuthRefresh;
